import CryptoJS from "crypto-js";
import { SECRET_KEY } from "../ServiceConnection/serviceconnection";


const send_null_value = "1";
const storeData = (key, value) => {
  try {
    localStorage.setItem(key, value);
  } catch (error) {
    // Handle the error
  }
};

// Retrieving data
const retrieveData = (key) => {
  try {
    const value = localStorage.getItem(key);
    if (value !== null) {
      if (key === "admin_id" || key === "admin_name" || key === "designation_name" || key === "access_permission" || key === "department_ids" || key === "admin_id" || key === "admin_id" || key === "default_restaurant_id" || key === "restaurant_name" || key === "packageName") {
        const print_value = decryptData(value);
        return print_value;
      }
      return value;
    }

    return send_null_value;
  } catch (error) {
    return send_null_value;
  }
};

// Removing data
const removeData = () => {
  try {
    sessionStorage.clear();
    localStorage.clear();
  } catch (error) {
    //err
  }
};


const decryptData = (cipherText) => {
  if (!cipherText) {
    throw new Error("cipherText is empty");
  }
  // 1️⃣ Normalize key
  const SECRET_KEY_STRING = SECRET_KEY.trim().slice(0, 16);
  // 2️⃣ Convert to WordArray (MANDATORY)
  const KEY = CryptoJS.enc.Utf8.parse(SECRET_KEY_STRING);
  // 3️⃣ Decrypt with SAME config as backend
  const decrypted = CryptoJS.AES.decrypt(cipherText, KEY, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7,
  });
  // 4️⃣ Convert to UTF-8
  const text = decrypted.toString(CryptoJS.enc.Utf8);
  if (!text) {
    throw new Error("Decryption failed (key/mode mismatch)");
  }
  return JSON.parse(text);
};

const encryptData = (data) => {
  // 1️⃣ Normalize key
  const SECRET_KEY_STRING = SECRET_KEY.trim().slice(0, 16);

  // 2️⃣ Convert to WordArray (MANDATORY)
  const KEY = CryptoJS.enc.Utf8.parse(SECRET_KEY_STRING);

  // 3️⃣ Encrypt with SAME config as backend
  const encrypted = CryptoJS.AES.encrypt(JSON.stringify(data), KEY, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7,
  });

  return encrypted.toString(); // Base64
};
export { storeData, retrieveData, removeData, decryptData, encryptData };
